"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageToAll = exports.createFromState = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var crokinolePucks_sidecar_1 = require("@crokinole/entities/crokinolePucks-sidecar");
var voyageMessageIds_1 = require("@voyage/multi/voyageMessageIds");
// This message is for the client to acknoledge the host that it knows about the game change
var namespace = 'crokinole-gameDrift';
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Crokinole_GameDrift;
function write(m, d) {
    var e_1, _a;
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    // Sync discs
    messageWriter_sidecar_1.messageWriter.write16(m, d.discs.length);
    try {
        for (var _b = __values(d.discs), _c = _b.next(); !_c.done; _c = _b.next()) {
            var disc = _c.value;
            messageWriter_sidecar_1.messageWriter.write32(m, disc.id);
            messageWriter_sidecar_1.messageWriter.writeFloat(m, disc.tx);
            messageWriter_sidecar_1.messageWriter.writeFloat(m, disc.ty);
            messageWriter_sidecar_1.messageWriter.writeFloat(m, disc.r);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var numDiscs = messageWriter_sidecar_1.messageWriter.read16(m);
    var discs = [];
    for (var i = 0; i < numDiscs; i++) {
        discs.push({
            id: messageWriter_sidecar_1.messageWriter.read32(m),
            tx: messageWriter_sidecar_1.messageWriter.readFloat(m),
            ty: messageWriter_sidecar_1.messageWriter.readFloat(m),
            r: messageWriter_sidecar_1.messageWriter.readFloat(m),
        });
    }
    var d = {
        discs: discs,
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        discs: [
            {
                id: 1,
                tx: 0.123,
                ty: 1.231,
                r: 2.23423,
            },
            {
                id: 3,
                tx: 3.2345234534523,
                ty: 4.23452345,
                r: 5.54343,
            },
        ],
    };
    messageWriter_sidecar_1.messageWriter.test(namespace + '|gameDrift', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, fromId) {
    var msgA = read(m);
    // Compare to current
    var msgB = createFromState();
    // Calculate drift
    var driftA = 0;
    var driftB = 0;
    var calcPuckDrift = function (msg) {
        var e_2, _a;
        var drift = 0;
        try {
            for (var _b = __values(msg.discs), _c = _b.next(); !_c.done; _c = _b.next()) {
                var disc = _c.value;
                drift += disc.tx;
                drift += disc.ty;
                drift += disc.r;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return drift;
    };
    driftA = calcPuckDrift(msgA);
    driftB = calcPuckDrift(msgB);
    var driftDelta = Math.abs(driftA - driftB);
    console.log(namespace, 'process', 'gameDrift', driftDelta);
}
exports.process = process;
function createFromState() {
    var discs = crokinolePucks_sidecar_1.crokinolePucks.getAll();
    var msg = {
        discs: discs.map(function (d) { return ({
            id: d.id,
            tx: d.rigidBody.translation().x,
            ty: d.rigidBody.translation().y,
            r: d.rigidBody.rotation(),
        }); }),
    };
    return msg;
}
exports.createFromState = createFromState;
function sendMessageToAll(msg) {
    websockets_sidecar_1.websockets._sendMessageToAll(write, msg, true);
}
exports.sendMessageToAll = sendMessageToAll;
